﻿(function () {
	const cardRoot = (btn) => btn.closest(".ec-video-with-text__video-card");

	const togglePlay = (btn) => {
		const card = cardRoot(btn);
		if (!card) return;
		const video = card.querySelector("video");
		const iframe = card.querySelector("iframe");

		if (video) {
			if (video.paused) {
				video.play().catch(() => {});
			} else {
				video.pause();
			}
			btn.classList.toggle("active");
		} else if (iframe) {
			if (iframe.classList.contains("video-pause")) {
				if (iframe.classList.contains("js-youtube")) {
					iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
					if (iframe.classList.contains("video-muted")) {
						iframe.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', "*");
					} else {
						iframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', "*");
					}
				} else if (iframe.classList.contains("js-vimeo")) {
					iframe.contentWindow.postMessage('{"method":"play"}', "*");
					if (iframe.classList.contains("video-muted")) {
						iframe.contentWindow.postMessage('{"method":"setVolume", "value":0}', "*");
					} else {
						iframe.contentWindow.postMessage('{"method":"setVolume", "value":1}', "*");
					}
				}
				iframe.classList.add("video-play");
				iframe.classList.remove("video-pause");
			} else {
				if (iframe.classList.contains("js-youtube")) {
					iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
				} else if (iframe.classList.contains("js-vimeo")) {
					iframe.contentWindow.postMessage('{"method":"pause"}', "*");
				}
				iframe.classList.add("video-pause");
				iframe.classList.remove("video-play");
			}
			btn.classList.toggle("active");
		}
	};

	const toggleSound = (btn) => {
		const card = cardRoot(btn);
		if (!card) return;
		const video = card.querySelector("video");
		const iframe = card.querySelector("iframe");

		if (video) {
			if (video.muted) {
				setTimeout(() => {
					video.muted = false;
				}, 10);
			} else {
				setTimeout(() => {
					video.muted = true;
				}, 10);
			}
			btn.classList.toggle("active");
		} else if (iframe) {
			if (iframe.classList.contains("video-muted")) {
				if (iframe.classList.contains("js-youtube")) {
					iframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', "*");
				} else if (iframe.classList.contains("js-vimeo")) {
					iframe.contentWindow.postMessage('{"method":"setVolume", "value":1}', "*");
				}
				iframe.classList.remove("video-muted");
			} else {
				if (iframe.classList.contains("js-youtube")) {
					iframe.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', "*");
				} else if (iframe.classList.contains("js-vimeo")) {
					iframe.contentWindow.postMessage('{"method":"setVolume", "value":0}', "*");
				}
				iframe.classList.add("video-muted");
			}
			btn.classList.toggle("active");
		}
	};

	const bind = (root) => {
		root.querySelectorAll(".ec-video-with-text .js-ec-play-video").forEach((btn) => {
			btn.addEventListener("click", (e) => {
				e.preventDefault();
				togglePlay(btn);
			});
		});
		root.querySelectorAll(".ec-video-with-text .js-ec-sound-video").forEach((btn) => {
			btn.addEventListener("click", (e) => {
				e.preventDefault();
				toggleSound(btn);
			});
		});
	};

	const observeAutoplay = (section) => {
		const video = section.querySelector(".ec-video-with-text video");
		if (!video) return;

		const btn = section.querySelector(".js-ec-play-video");

		const io = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						video.play().catch(() => {});
						if (btn) btn.classList.add("active");
					} else {
						video.pause();
						if (btn) btn.classList.remove("active");
					}
				});
			},
			{ threshold: 0.3 }
		);

		io.observe(section);
	};

	const initSection = (section) => {
		if (!section || !section.classList.contains("ec-video-with-text-section")) return;
		bind(section);
		observeAutoplay(section);
		section.querySelectorAll(".ec-video-with-text__video-card video").forEach((video) => {
			const card = video.closest(".ec-video-with-text__video-card");
			const btn = card?.querySelector(".js-ec-play-video");
			const loopOff = card?.getAttribute("data-video-loop") === "false";
			if (loopOff && btn) {
				video.addEventListener("ended", () => btn.classList.remove("active"));
			}
		});
	};

	document.querySelectorAll(".shopify-section.ec-video-with-text-section").forEach(initSection);

	document.addEventListener("shopify:section:load", (e) => {
		initSection(e.target);
	});
})();
